import bhaggy from "../src/assets/projectImgs/bhagwanyoga.png";
import geographica from "../src/assets/projectImgs/geographica.png";
import guessMyNumber2 from "../src/assets/projectImgs/guessmynumber2.png";
import cyberjump from "../src/assets/projectImgs/cyberjump.png";

export const projects = [
  {
    id: "1",
    name: "Bhagwan Yoga",
    description: "E-commerce website created using React",
    url: "https://bhagwanyoga.netlify.app",
    img: bhaggy,
  },
  {
    id: "2",
    name: "Geographica",
    description: "Map application created using MapBox API",
    url: "https://geographica.netlify.app/",
    img: geographica,
  },
  {
    id: "3",
    name: "Guess my number",
    description: "Guessing Game created using vanilla JS",
    url: "https://antonmaenpaa.github.io/quiz-app/login.html",
    img: guessMyNumber2,
  },
  {
    id: "4",
    name: "Cyber jump",
    description: "Game created using p5.js",
    url: "https://cyberjump.netlify.app/",
    img: cyberjump,
  },
];
